export const ADMIN_SUPERPOWER_TRANSLATION_NAMESPACE = "admin-superpower";

export const ADMIN_SUPERPOWER_TK = "ADMIN_SUPERPOWER_TK";

export const VITE_ACTIVATE_USER_ID_SUPERPOWER_TAB = import.meta.env
    .VITE_ACTIVATE_USER_ID_SUPERPOWER_TAB;
